import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "row", "stateButton", "empty"]
  static values = { state: { type: String, default: "all" } }

  connect() {
    this.filter()
    this.#highlightState()
  }

  rowTargetConnected() {
    this.filter()
  }

  rowTargetDisconnected() {
    this.filter()
  }

  selectState(event) {
    this.stateValue = event.currentTarget.dataset.alertsTableStateParam || "all"
    this.#highlightState()
    this.filter()
  }

  filter() {
    const query = this.hasQueryTarget ? this.queryTarget.value.trim().toLowerCase() : ""
    let visibleCount = 0

    this.rowTargets.forEach((row) => {
      const matchesState = this.stateValue === "all" || row.dataset.alertsTableState === this.stateValue
      const matchesQuery = !query || row.dataset.alertsTableSearch.includes(query)
      const visible = matchesState && matchesQuery

      row.classList.toggle("hidden", !visible)
      if (visible) visibleCount += 1
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visibleCount > 0)
    }
  }

  #highlightState() {
    this.stateButtonTargets.forEach((button) => {
      const active = button.dataset.alertsTableStateParam === this.stateValue
      button.classList.toggle("text-ink", active)
      button.classList.toggle("border-brand", active)
      button.classList.toggle("text-ink-slate", !active)
      button.classList.toggle("border-transparent", !active)
      button.setAttribute("aria-pressed", active ? "true" : "false")

      const pill = button.querySelector("span")
      if (pill) {
        pill.classList.toggle("bg-brand/[.08]", active)
        pill.classList.toggle("text-brand-deep", active)
        pill.classList.toggle("bg-well", !active)
        pill.classList.toggle("text-ink-slate", !active)
      }
    })
  }
}
